export default __webpack_public_path__ + "static/hero-left-58beacaab5603aec12b8ebb3e5f25c30.svg";